import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BiTimeChart } from '@/features/dashboard-finance/charts/BiTimeChart';
import { formatInt } from '@/features/dashboard-finance/formatters';
import type { UsageBucket } from './useUsage';

const ORDER: UsageBucket[] = ['B0_10', 'B11_50', 'B51_200', 'B201_1000', 'B1000_PLUS'];

/** Quantos tenants caem em cada faixa de etiquetas impressas (`UsageBucket`). */
export function DistributionChart({
  distribution,
}: {
  distribution: Record<UsageBucket, number>;
}): React.JSX.Element {
  const { t } = useTranslation();
  const data = ORDER.map((bucket) => ({
    x: t(`usage.distribution.bucket.${bucket}`),
    y: distribution[bucket],
  }));

  return (
    <BiTimeChart
      title={t('usage.distribution.title')}
      type="bar"
      data={data}
      color="#9333ea"
      valueFormatter={(v): string => formatInt(v)}
    />
  );
}
